"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (a, b) {
    if (a.length !== b.length) {
        return false;
    }

    return !a.some(function (x, idx) {
        return x !== b[idx];
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/array/arrayEqual.js
// module id = 42
// module chunks = 0